<template>
  <collapsible-section class='_pt0 _pb0' :collapsed='false'>
    <template #headerText>
      <p class='color-leaf'>Member Demographics</p>
    </template>
    <template #collapsibleSection class='advanced-table-section-header'>
      <async-loader v-if='loading'/>
      <div v-else container>
        <div row>
          <div class="_mbs">
            <div grid>
              <div column="3">
                <app-labeled-data
                  :data='address.line1'
                  label='Address Line 1:'
                  />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='address.line2'
                  label='Address Line 2:'
                  />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='address.line3'
                  label='Address Line 3:'
                  />
              </div>
            </div>
            <div grid>
              <div column="3">
                <app-labeled-data
                  :data='address.zip'
                  label='Zip Code:'
                  />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='address.city'
                  label='City:'
                  />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='address.state'
                  label='State:'
                  />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='address.county'
                  label='County'
                  />
              </div>
            </div>
            <div grid>
              <div column="3">
                <app-labeled-data
                  :data='address.phone'
                  label='Phone Number:'
                  />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='address.email'
                  label='Email Address:'
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import CollapsibleSection from '@sections/CollapsibleSection'
  import AppLabeledData from '@molecules/LabeledData'
  import AsyncLoader from '@molecules/AsyncLoader'

  export default {
    components: {
      CollapsibleSection,
      AppLabeledData,
      AsyncLoader
    },
    props: {
      address: {
        type: Object,
        default() {
          return {
            email: '',
            phone: '',
            line1: '',
            line2: '',
            line3: '',
            zip: '',
            city: '',
            state: '',
            county: ''
          }
        }
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
